import { sileo } from "sileo";

export const notify = {
  success: (message: string, description?: string) => {
    sileo.success({ title: message, description });
  },
  error: (message: string, description?: string) => {
    sileo.error({ title: message, description });
  },
  warning: (message: string, description?: string) => {
    sileo.warning({ title: message, description });
  },
  info: (message: string, description?: string) => {
    sileo.info({ title: message, description });
  },
  promise: <T>(
    promise: Promise<T> | (() => Promise<T>),
    messages: {
      loading: string;
      success: string | ((data: T) => string);
      error: string | ((error: unknown) => string);
    }
  ) => {
    return sileo.promise(promise, {
      loading: { title: messages.loading },
      success: (data) => ({
        title:
          typeof messages.success === "function"
            ? messages.success(data)
            : messages.success,
      }),
      error: (err) => ({
        title:
          typeof messages.error === "function"
            ? messages.error(err)
            : messages.error,
      }),
    });
  },
};
